import React from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import Badge from '../ui/Badge';
import ProgressBar from '../ui/ProgressBar';
import { useT, useLocale } from '../../i18n/LocaleContext';
import { formatCurrency, formatDate } from '../../utils/format';

const STATUS_TONE = { open: 'open', closed: 'pending', completed: 'completed', cancelled: 'inactive' };

export default function EventDetailModal({ isOpen, onClose, event, onEdit }) {
  const t = useT();
  const { locale } = useLocale();
  if (!event) return null;
  const progress = event.capacity ? (event.registered / event.capacity) * 100 : 0;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('events.view_event')}
      size="md"
      footer={(
        <>
          <Button variant="ghost" onClick={onClose}>{t('common.close')}</Button>
          {onEdit && <Button variant="primary" onClick={onEdit}>{t('common.edit')}</Button>}
        </>
      )}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', marginBottom: '16px' }}>
        <div>
          <div style={{ fontFamily: "'Cinzel', serif", fontSize: '16px', color: 'var(--blue-deep)' }}>{event.name}</div>
          <div className="mono" style={{ marginTop: '4px' }}>{event.code || event.id}</div>
        </div>
        <Badge tone={STATUS_TONE[event.status]}>{t(`events.statuses.${event.status}`)}</Badge>
      </div>

      <div className="detail-grid">
        <div>
          <div className="detail-item-label">{t('events.field_destination')}</div>
          <div className="detail-item-value">{event.destination}</div>
        </div>
        <div>
          <div className="detail-item-label">{t('events.field_date')}</div>
          <div className="detail-item-value">{formatDate(event.date, t)}</div>
        </div>
        <div>
          <div className="detail-item-label">{t('events.field_capacity')}</div>
          <div className="detail-item-value">{event.capacity > 0 ? event.capacity : t('events.no_limit')}</div>
        </div>
        <div>
          <div className="detail-item-label">{t('events.field_registered')}</div>
          <div className="detail-item-value">
            {t('events.registered_count', { count: event.registered, percent: Math.round(progress) })}
          </div>
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <ProgressBar value={progress} />
        </div>
        <div>
          <div className="detail-item-label">{t('events.field_price')}</div>
          <div className="detail-item-value"><strong>{formatCurrency(event.price, locale)}</strong></div>
        </div>
        <div>
          <div className="detail-item-label">{t('events.field_description')}</div>
          <div className="detail-item-value">{event.description || '—'}</div>
        </div>
      </div>
    </Modal>
  );
}
